import moment from 'moment';

const getColumnTitle = (column) => {
  if (typeof column === 'string') return column;
  if (typeof column === 'object') {
    if (typeof column.title !== 'undefined') return column.title;
    // if (column.name) return column.name;
  }
  return undefined;
};

const getColumnName = (column) => {
  if (typeof column === 'string') return column;
  if (typeof column === 'object' && column.name) return column.name;
  return '';
};

const getSortName = (column) => {
  if (column.sortName) return column.sortName;
  if (typeof column === 'string') return column;
  if (typeof column === 'object' && column.name) return column.name;
  return '';
};

const convertingDate = (data, type, format) => {
  if (type === 'last_login' || type === 'created_at') {
    return moment(data[type]).format(format);
  }
  if(type === 'time'){
    return moment(data[type]).format('HH:mm, MMM D');
  }
  if (type === 'full_name') {
    if (!data.first_name || !data.last_name) {
      return data.email;
    }
    return `${data.first_name} ${data.last_name}`;
  }
  if (type === 'creator') {
    if (!data.creator) {
      return 'None';
    }
  }
  return data[type];
};

const getCellValue = (column, item, service, updateData, destroyItem) => {
  const value = convertingDate(item, column.name, 'll');
  const name = getColumnName(column);
  if (name) {
    if (typeof column.value === 'function') return column.value({ column, item, service, updateData, destroyItem });
    if (typeof item[name] === 'undefined' && !value) return 'None';
    return value;
  }
  return undefined;
};

const getCellClass = (value) => {
  if (value === 'None') return 'tb-td tb-empty tb';
  if (value && value.props && (value.props.type === 'status' || value.props.name === 'status')) return 'tb-td customertabledrop tb';
  return 'tb-td tb';
};

const tdId = (item, column) => `td-${item.id}-${getColumnName(column)}${column.id}`;
const trId = item => `tr-${item.id}`;
const thId = column => `th-${getColumnName(column)}${column.id}`;
const fId = column => `f-${getColumnName(column)}${column.id}`;

const getPageCount = (count, pageSize) => Math.ceil(count / pageSize);

export default { getColumnTitle, getColumnName, getCellValue, tdId, trId, thId, getPageCount, fId, getCellClass, getSortName };



// WEBPACK FOOTER //
// ./src/components/list/grid/grid.helper.js